import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import CameraDTO from '../../../dto/CameraDTO';
import { optionClassFormatter } from '../../../utils/formatters';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import FilterDTO from '../../../dto/FilterDTO';
import RadioButton from '../../../components/fields/RadioButton/RadioButton';
import { getCheckClassByName } from '../camera-utils';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import TextInput from '../../../components/fields/TextInput/TextInput';
import {
  CAMERA_STATUS, CAMERA_AVAILABLE_STATUS, deviceKeysT, processingKeysT,
} from '../constants';
import CheckBoxAccordion from '../../../components/fields/CheckBoxInput/CheckBoxList';
import RadioList from '../../../components/fields/CheckBoxInput/RadioList';

const updatePeriods = [
  { value: 0, name: 'Не обновлять' },
  { value: 10, name: '10 секунд' },
  { value: 30, name: '30 секунд' },
  { value: 60, name: '1 минута' },
  { value: 300, name: '5 минут' },
];

export function FilterPresets(props) {
  const {
    keys = [],
    errorKeys = [],
    warningKeys = [],
    setValue,
    getValues,
    resetField,
  } = props;

  const isSelectOnly = (values = []) => values.every(e => getValues(e));

  const selectPreset = isError => () => {
    const keys = isError ? errorKeys : warningKeys;
    const isSelected = isSelectOnly(keys);
    const formData = getValues();

    for (let i = 0; i < keys.length; i++) {
      const current = keys[i];
      if (!isSelected) {
        setValue(current, !formData[current] ? keys.includes(current) : formData[current]);
      } else {
        resetField(current);
      }
    }
  };

  return (
    <div className="form-block-presets">
      <Button
        className={classNames('presets-button', { active: isSelectOnly(errorKeys, keys) })}
        variant="secondary"
        onClick={selectPreset(true)}
      >Ошибка
      </Button>
      <Button
        className={classNames('presets-button', { active: isSelectOnly(warningKeys, keys) })}
        variant="secondary"
        onClick={selectPreset(false)}
      >Некритическая поломка
      </Button>
    </div>
  );
}

export default function MobileCamerasFilter(props) {
  const {
    onHide, resetField, meta, reset = () => { }, zones, register, getValues, setValue, defaultValues, handleLoadingHostList = () => { },
    changeUpdatePeriod = () => { },
    updatePeriod,
  } = props;
  const DTO = new CameraDTO();
  const filterDto = new FilterDTO();
  const attributes = DTO.getAttributesByName();
  const filterAttributes = filterDto.getAttributesByName();
  const availableStatusOptions = Object.values(CAMERA_AVAILABLE_STATUS).map(v => ({ value: Number(v), nameId: `cameras.available_status.${v}` })).reverse();
  const statusOptions = Object.values(CAMERA_STATUS).map(v => ({ value: Number(v), nameId: `cameras.status.${v}` })).reverse();
  const zonesOptions = zones.map(i => ({ name: i, value: i }));
  const selectedStatus = statusOptions.find(i => i.value === Number(getValues('status')));
  const selectedAvailableStatus = availableStatusOptions.find(i => i.value === Number(getValues('available_status')));
  const onShow = () => {
    handleLoadingHostList();
  };
  const clear = () => {
    reset(defaultValues);
  };

  const renderCheckBox = (name, index) => (
    <FieldWithAttributeDTO
      key={index}
      type="text"
      component={CheckBoxInputWithLabel}
      dtoObject={filterAttributes[name]}
      className={getCheckClassByName(name)}
      withLabel
      addPlaceholder
      variant="material"
      inputProps={{
        value: getValues(name),
        ...register(name),
        onChange: () => setValue(name, !getValues(name)),
      }}
    />
  );

  return (
    <Dialog
      className={classNames('parking-meter-full-filter mobile')}
      onClose={onHide}
      open
    >
      <DialogTitle
        className="pmff-title"
        title={(
          <>
            <div className="pmff-title-text f2">Фильтры</div>
            <div className="pmff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="pmff-close" onClick={onHide} />
            </div>
          </>
        )}
      />
      <DialogContent className="pff-content">
        <form>
          <CustomSelectInput
            label="Период обновления"
            placeholder="Период обновления"
            dtoObject={attributes.status}
            inputProps={{
              value: getValues('update_period'),
              ...register('update_period'),
              onChange: event => { setValue('update_period', event.target.value || 0); changeUpdatePeriod(event.target.value || 0); },
            }}
            options={updatePeriods}
            className="search-field"
            variant="material"
            withLabel
          />
          <FieldWithAttributeDTO
            type="text"
            component={TextInput}
            withLabel
            dtoObject={{
              name: 'query',
              type: String,
              validators: [],
              labelKey: 'search',
            }}
            inputProps={{
              ...register('query', { maxLength: 30 }),
              value: getValues('query'),
            }}
            className="search-field"
            variant="material"
          />
          <FieldWithAttributeDTO
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.zbx_address}
            inputProps={{
              value: getValues('address'),
              ...register('address'),
            }}
            variant="material"
            withLabel
          />
          <FieldWithAttributeDTO
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.host}
            className="mt-4"
            inputProps={{
              value: getValues('host'),
              ...register('host'),
            }}
            variant="material"
            withLabel
          />
          <FieldWithAttributeDTO
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.zbx_zone}
            addPlaceholder
            options={zonesOptions}
            inputProps={{
              ...register('zbx_zone'),
              value: getValues('zbx_zone'),
              onChange: e => {
                setValue('zbx_zone', e.target.value);
              },
            }}
            variant="material"
            withLabel
          />
          <RadioList label="Доступность" selectedValue={selectedAvailableStatus} clearFilter={() => reset({ ...getValues(), available_status: 0 })} filter={getValues()} keys={[]}>
            <FieldWithAttributeDTO
              type="text"
              component={RadioButton}
              dtoObject={attributes.available_status}
              className="mt-4"
              withLabel
              addPlaceholder
              options={availableStatusOptions}
              optionClassFormatter={optionClassFormatter}
              inputProps={{
                ...register('available_status'),
                value: Number(getValues('available_status')),
                onChange: e => {
                  setValue('available_status', Number(e.target.value));
                },
              }}
            />
          </RadioList>
          <RadioList label="Состояние" selectedValue={selectedStatus} clearFilter={() => reset({ ...getValues(), status: 0 })} filter={getValues()} keys={[]}>
            <FieldWithAttributeDTO
              type="text"
              component={RadioButton}
              dtoObject={attributes.status}
              className="mt-4"
              withLabel
              addPlaceholder
              options={statusOptions}
              optionClassFormatter={optionClassFormatter}
              inputProps={{
                ...register('status'),
                value: Number(getValues('status')),
                onChange: e => {
                  setValue('status', Number(e.target.value));
                },
              }}
            />
          </RadioList>
          <CheckBoxAccordion label="Статус" clearFilter={() => reset({ ...getValues(), ...deviceKeysT })} setFilterValue={setValue} filter={getValues()} keys={Object.keys(deviceKeysT)}>
            <FilterPresets
              keys={Object.keys(deviceKeysT)}
              errorKeys={['DS_ERROR']}
              warningKeys={['DS_UNKNOWN',
                'DS_NO_INIT_CAMERA',
                'DS_NO_INIT_DETECTION',
                'DS_NO_INIT_DETECT_VIOLATION']}
              setValue={setValue}
              getValues={getValues}
              reset={reset}
              resetField={resetField}
            />
            {Object.keys(deviceKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Процессинг" clearFilter={() => reset({ ...getValues(), ...processingKeysT })} setFilterValue={setValue} filter={getValues()} keys={Object.keys(processingKeysT)}>
            {Object.keys(processingKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
        </form>
      </DialogContent>
      <DialogFooter className="pmff-footer">
        <div className="pmff-footer-buttons">
          <Button className="pmff-clear-data" variant="secondary" onClick={clear}>Сбросить</Button>
          <Button className="pmff-clear-show" onClick={() => { onHide(); onShow(); }}>Показать</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
